import React from 'react';
import { usePersonalMeetingCornerState } from './PersonalMeetingCorner.state';
import { PersonalMeetingCornerView } from './PersonalMeetingCorner.view';

const PersonalMeetingCorner: React.FC = () => {
    const state = usePersonalMeetingCornerState();
    return <PersonalMeetingCornerView {...state} />;
};

export default PersonalMeetingCorner;
